(function() {
  'use strict';

  function init() {
    var mobile = window.matchMedia('(max-width: 749px)');
    if (!mobile.matches) return;
    var images = document.querySelectorAll('main img');
    var activeOverlay = null;

    function openImage(original) {
      if (!mobile.matches || activeOverlay) return;
      var overlay = document.createElement('div');
      overlay.className = 'ks-zoom-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', '拡大画像');
      var image = document.createElement('img');
      image.src = original.currentSrc || original.src;
      image.alt = original.alt;
      image.style.width = original.naturalWidth + 'px';
      var closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'ks-zoom-close';
      closeButton.textContent = '閉じる';
      var previousOverflow = document.documentElement.style.overflow;

      function close() {
        document.removeEventListener('keydown', onKey);
        document.removeEventListener('focusin', onFocus);
        overlay.parentNode.removeChild(overlay);
        activeOverlay = null;
        document.documentElement.style.overflow = previousOverflow;
        original.focus();
      }
      function onKey(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          close();
        } else if (event.key === 'Tab' || event.keyCode === 9) {
          event.preventDefault();
          closeButton.focus();
        }
      }
      function onFocus(event) {
        if (!overlay.contains(event.target)) closeButton.focus();
      }

      closeButton.addEventListener('click', close);
      overlay.addEventListener('click', function(event) {
        if (event.target === overlay) close();
      });
      overlay.appendChild(image);
      overlay.appendChild(closeButton);
      document.body.appendChild(overlay);
      activeOverlay = overlay;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      document.addEventListener('focusin', onFocus);
      closeButton.focus();
    }

    function qualify(image) {
      if (!mobile.matches || image.classList.contains('ks-zoomable')) return;
      var ancestor = image.parentElement;
      while (ancestor) {
        if (/^(A|BUTTON|LABEL|HEADER|FOOTER)$/.test(ancestor.tagName) ||
            ancestor.getAttribute('role') === 'button' ||
            ancestor.getAttribute('aria-hidden') === 'true') return;
        // ヒーローの写真は拡大しても情報が増えない（商品ページで誤爆した）
        if (/hero/i.test(ancestor.id) || /hero/i.test(ancestor.className)) return;
        ancestor = ancestor.parentElement;
      }
      // 親が横並び（flex・grid）だとヒントの文字が縦1列に潰れるので付けない
      var hintParent = image.parentElement.tagName === 'PICTURE' ? image.parentElement.parentElement : image.parentElement;
      var parentDisplay = window.getComputedStyle(hintParent).display;
      if (/flex|grid/.test(parentDisplay) && window.getComputedStyle(hintParent).flexDirection !== 'column') return;
      var width = image.getBoundingClientRect().width;
      if (width < 200 || image.naturalWidth < width * 1.5 ||
          window.getComputedStyle(image).objectFit === 'cover') return;

      image.classList.add('ks-zoomable');
      image.setAttribute('role', 'button');
      image.setAttribute('tabindex', '0');
      image.setAttribute('aria-label', image.alt ? image.alt + '（タップで拡大）' : '画像を拡大');
      var hint = document.createElement('span');
      hint.className = 'ks-zoom-hint';
      hint.textContent = 'タップで拡大';
      var anchor = image.parentElement.tagName === 'PICTURE' ? image.parentElement : image;
      anchor.parentNode.insertBefore(hint, anchor.nextSibling);
      image.addEventListener('click', function() { openImage(image); });
      image.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          openImage(image);
        }
      });
    }

    function watch(image) {
      if (image.complete && image.naturalWidth > 0) {
        qualify(image);
      } else {
        image.addEventListener('load', function() { qualify(image); });
      }
    }
    for (var i = 0; i < images.length; i++) watch(images[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
